import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;
  return {
    skeleton: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      padding: "8px 0",
      "& .react-loading-skeleton": { borderRadius: 999 }
    },
    // Matches CategoryHorizontalTilePart; brand-tint disc per the Home artboard
    dealsTile: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      padding: "8px 0",
      borderRadius: radius.tile,
      color: color.ink,
      textDecoration: "none",
      "&:hover": { color: color.ink }
    },
    dealsDisc: {
      width: 84,
      height: 84,
      borderRadius: radius.pill,
      backgroundColor: color.brandTint,
      color: color.brandText,
      fontSize: fontSize.h2,
      fontWeight: 800,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "transform .25s ease"
    },
    dealsName: {
      fontSize: fontSize.ui,
      fontWeight: 600,
      textAlign: "center",
      lineHeight: 1.25,
      minHeight: 36,
      transition: "color .15s ease"
    },
    // hover last: JSS resolves $refs only to classes defined above
    [theme.media.hover]: {
      dealsTile: {
        "&:hover $dealsDisc": { transform: "scale(1.06)" },
        "&:hover $dealsName": { color: color.brandText }
      }
    }
  };
});

export default withCustomStyles;
